import router from "../axios";
import config from "../../config/index"
const { baseUrl } = config;

/**
 * LCD素材模块
**/
function getMaterialList(data) {
  return router({
    url: baseUrl + "lcdMaterial/v1/getList",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 获取素材列表分辨率
function getPixels(data) {
  return router({
    url: baseUrl + "lcdMaterial/v1/getPixels",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 获取路由（后端根据缓存token返回当前用户所有权限的菜单）
function uploadImage(data) {
  return router({
    url: baseUrl + "lcdMaterial/v1/upload/file",
    data: data,
    method: "POST",
  });
}

// 批量上传素材接口
function batchCreateImages(data) {
  return router({
    url: baseUrl + "lcdMaterial/v1/batchCreate",
    data: data,
    method: "POST",
  });
}

// 编辑素材
function updateImage(data) {
  return router({
    url: baseUrl + "lcdMaterial/v1/updateMaterial",
    data: data,
    method: "POST",
  });
}

// 删除素材
function deleteMaterial(data) {
  return router({
    url: baseUrl + "lcdMaterial/v1/delete",
    data: data,
    method: "POST",
  });
}

// 单个素材审核
function auditMaterial(data) {
  return router({
    url: baseUrl + "lcdMaterial/v1/audit",
    data: data,
    method: "POST",
  });
}

// 批量审核素材

function batchAuditMaterial(data) {
  return router({
    url: baseUrl + "lcdMaterial/v1/batchAudit",
    data: data,
    method: "POST",
  });
}

/**
 * LCD模板相关
**/
// 获取模板列表
function getTemplateList(data) {
  return router({
    url: baseUrl + "lcdTemplate/v1/getList",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 获取模板详情
function getTemplateInfo(data) {
  return router({
    url: baseUrl + "lcdTemplate/v1/getInfo",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 新增模板
function createInfo(data) {
  return router({
    url: baseUrl + "lcdTemplate/v1/createInfo",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 编辑模板
function updateInfo(data) {
  return router({
    url: baseUrl + "lcdTemplate/v1/updateInfo",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 复制模板
function copyInfo(data) {
  return router({
    url: baseUrl + "lcdTemplate/v1/copyInfo",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 发布模板
function activeInfo(data) {
  return router({
    url: baseUrl + "lcdTemplate/v1/activeInfo",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 取消发布模板
function unActiveInfo(data) {
  return router({
    url: baseUrl + "lcdTemplate/v1/unActiveInfo",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 保存模板样式
function saveJson(data) {
  return router({
    url: baseUrl + "lcdTemplate/v1/saveStyle",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 删除模板

function deleteInfo(data) {
  return router({
    url: baseUrl + "lcdTemplate/v1/deleteInfo",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}


/**
 * LCD设备管理模块
**/
// 获取lcd设备列表
function getDeviceList(data) {
  return router({
    url: baseUrl + "lcd/screen/v1/getList",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 物理删除lcd屏
function screenPhysicalDelete(data) {
  return router({
    url: baseUrl + "lcd/screen/v1/physicalDelete",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 批量物理删除lcd屏
function screenBatchPhysicalDelete(data) {
  return router({
    url: baseUrl + "lcd/screen/v1/batchPhysicalDelete",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// lcd屏详情
function screenDetail(data) {
  return router({
    url: baseUrl + "lcd/screen/v1/get",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 物理删除菜单
function physicalDeleteMenu(data) {
  return router({
    url: baseUrl + "menu/v1/physicalDeleteMenu",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// lcd绑定模板
function screenTemplateBind(data) {
  return router({
    url: baseUrl + "lcd/screen/commond/v1/template/bind",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// lcd绑定商品
function screenItemBind(data) {
  return router({
    url: baseUrl + "lcd/screen/commond/v1/item/bind",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// lcd解绑商品  
function screenItemUnbind(data) {
  return router({
    url: baseUrl + "lcd/screen/commond/v1/item/unbind",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// lcd屏唤醒
function screenWake(data) {
  return router({
    url: baseUrl + "lcd/screen/commond/v1/wake",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// lcd屏休眠
function screenSleep(data) {
  return router({
    url: baseUrl + "lcd/screen/commond/v1/sleep",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// lcd熄屏
function screenClose(data) {
  return router({
    url: baseUrl + "lcd/screen/commond/v1/close",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// lcd重启screenRestart
function screenRestart(data) {
  return router({
    url: baseUrl + "lcd/screen/commond/v1/restart",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// lcd任务列表
function screenTaskList(data) {
  return router({
    url: baseUrl + "lcd/screen/task/v1/getList",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// lcd任务详情
function screenTaskDetail(data) {
  return router({
    url: baseUrl + "lcd/screen/task/v1/get",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 绑定商品 商品列表搜索结果接口
function getItemList(data) {
  return router({
    url: baseUrl + "app/item/v1/getItemList",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 获取场景静态字段列表
function scenarioFiledList(data) {
  return router({
    url: baseUrl + "scenario/v1/static/filed/list",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 获取场景下的字段--获取场景详情
function getScenario(data){
  return router({
    url: baseUrl + "scenario/v1/getScenario",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}


// lcd屏重推
function screenRepush(data){
  return router({
    url: baseUrl + "lcd/screen/commond/v1/repush",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 门店级重推
function storeScreenRepush(data){
  return router({
    url: baseUrl + "lcd/screen/commond/v1/batchRepush",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 门店级唤醒
function storeScreenWake(data){
  return router({
    url: baseUrl + "lcd/screen/commond/v1/batchWake",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 门店级休眠
function storeScreenSleep(data){
  return router({
    url: baseUrl + "lcd/screen/commond/v1/batchSleep",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 门店级定时息屏
function storeScreenClose(data){
  return router({
    url: baseUrl + "lcd/screen/commond/v1/batchClose",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 门店级别重启
function storeScreenRestart(data){
  return router({
    url: baseUrl + "lcd/screen/commond/v1/batchRestart",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 门店级模板绑定
function storeTemplateBind(data){
  return router({
    url: baseUrl + "lcd/screen/commond/v1/template/batchBind",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}



// 营销投放相关
// 获取营销投放列表
function adLaunchList(data){
  return router({
    url: baseUrl + "lcd/template/launch/v1/getList",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 营销广告投放新增
function adLaunch(data){
  return router({
    url: baseUrl + "lcd/template/launch/v1/launch",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}
// 删除投放
function adLaunchDelete(data){
  return router({
    url: baseUrl + "lcd/template/launch/v1/delete",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 终止投放
function endLaunch(data){
  return router({
    url: baseUrl + "lcd/template/launch/v1/end",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 设置屏幕安装方式
function setInstallType(data){
  return router({
    url: baseUrl + "lcd/screen/v1/update/installType",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 设置设备标签
function setLabelType(data){
  return router({
    url: baseUrl + "lcd/screen/v1/update/labelType",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}



// 获取ESL模板详情
function getEslTemplateInfo(data) {
  return router({
    url: baseUrl + "template/v1/get",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}


// 保存ESL价签模板
function saveEslJson(data) {
  return router({
    url: baseUrl + "template/v1/svgSaveOrUpdate",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 获取ESL素材库图片
function getEslImages(data) {
  return router({
    url: baseUrl + "image/v1/getList",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 获取ESL单个素材图片的不同色彩值下的url
function getEslImageColorUrl(data) {
  return router({
    url: baseUrl + "image/v1/get",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}


// 获取自动运营历史列表
function getAutoTempList(data){
  return router({
    url: baseUrl + "lcd/template/autoOperation/v1/getList",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 添加LCD节日模板自动下发
function autoTempOperation(data){
  return router({
    url: baseUrl + "lcd/template/autoOperation/v1/create",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 删除未开始自动运营任务
function delAutoTempOperation(data){
  return router({
    url: baseUrl + "lcd/template/autoOperation/v1/physicalDelete",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}


// 物理删除lcd自动运营记录
function delAutoTempList(data){
  return router({
    url: baseUrl + "lcd/template/autoOperation/v1/physicalDelete",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 获取素材详情
function getMaterialDetail(data){
  return router({
    url: baseUrl + "lcdMaterial/v1/get",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

export {
  getMaterialList,
  getPixels,
  uploadImage,
  batchCreateImages,
  updateImage,
  deleteMaterial,
  auditMaterial,
  batchAuditMaterial,
  getTemplateList,
  getTemplateInfo,
  createInfo,
  updateInfo,
  copyInfo,
  activeInfo,
  unActiveInfo,
  saveJson,
  deleteInfo,
  getDeviceList,
  screenPhysicalDelete,
  screenBatchPhysicalDelete,
  screenDetail,
  screenTemplateBind,
  screenItemBind,
  screenItemUnbind,
  screenWake,
  screenSleep,
  screenClose,
  screenRestart,
  screenTaskList,
  screenTaskDetail,
  getItemList,
  scenarioFiledList,
  getScenario,
  screenRepush,
  storeScreenRepush,
  storeScreenSleep,
  storeScreenWake,
  storeScreenClose,
  storeScreenRestart,
  storeTemplateBind,
  adLaunchList,
  adLaunch,
  adLaunchDelete,
  endLaunch,
  setInstallType,
  setLabelType,
  getEslTemplateInfo,
  saveEslJson,
  getEslImages,
  getEslImageColorUrl,
  
  autoTempOperation,
  delAutoTempOperation,
  delAutoTempList,
  getAutoTempList,
  getMaterialDetail,
}